// Used in composite-assignment-submit.component.html and singular-assignment.component.html

// Angular
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { MatTabChangeEvent } from "@angular/material/tabs";

// Services/Types/Helpers
import { PPAssignment as Assignment } from "cli-types";
import { AssignmentUpload } from "#models/assignmentUpload.interface";

// Components
import { AssignmentUploaderComponent } from "#components/assignments/assignment-uploader/assignment-uploader.component";

@Component({
    selector: "makequest-iframe",
    templateUrl: "./makequest-iframe.component.html",
    styleUrls: ["./makequest-iframe.component.scss"],
    standalone: false
})
export class MakequestIframeComponent implements OnInit {
    showUploads = false;
    embedUrl: SafeResourceUrl;
    uploadPath: string;
    deletePath: string;
    fileSet: boolean;
    isButtonDisabled = true;
    tabs = [{ name: "MakeQuest" }, { name: "File Uploader" }];
    currentTab: number;

    @Input() assignment: Assignment;

    @Output() public getFullAssignment = new EventEmitter<number>();

    @ViewChild(AssignmentUploaderComponent)
    assignmentUploaderComponent: AssignmentUploaderComponent;

    constructor(private domSanitizer: DomSanitizer) {}

    ngOnInit(): void {
        this.uploadPath =
            (<any>window).apiHost +
            "/api/assignments/" +
            this.assignment.assignmentID +
            "/upload-file";
        this.deletePath =
            (<any>window).apiHost +
            "/api/assignments/" +
            this.assignment.assignmentID +
            "/remove-file";
        this.embedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
            "https://makequest.carnegielearning.com"
        );
        this.currentTab = 0;

        this.getFullAssignment.emit(this.assignment.assignmentID);
    }

    handleSuccess(response: AssignmentUpload) {
        this.getFullAssignment.emit(this.assignment.assignmentID);
    }

    checkFileSubmission(event: boolean) {
        this.fileSet = !!event;
        this.isDisabledButton();
    }

    tabChange(event: MatTabChangeEvent) {
        this.currentTab = event.index;
    }

    submitFiles() {
        this.assignmentUploaderComponent.uploadAssignment();
    }

    isDisabledButton() {
        if (this.fileSet === true) {
            this.isButtonDisabled = false;
        } else if (this.fileSet === false) {
            this.isButtonDisabled = true;
        }
    }
}
